
export interface FilterCardData {
  show?: boolean,
  label?: string,
  icon?: string,
  active: boolean,
  filter?: string
}
